"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var VideoComponent =
/*#__PURE__*/
function () {
  function VideoComponent() {
    _classCallCheck(this, VideoComponent);

    this.init();
  }

  _createClass(VideoComponent, [{
    key: "init",
    value: function init() {
      $(document).on('click', '.ytVideo', function (e) {
        var _this = $(e.currentTarget);

        var src = _this.attr("data-yt");

        $("#ytVideo iframe").attr("src", 'https://www.youtube.com/embed/' + src);
        $("#ytVideo").modal();
        return false;
      });
    }
  }]);

  return VideoComponent;
}();